import { Check } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { ServicePayments } from "../components/ServicePayments";
import { SERVICES, WORKFLOW, IMAGES } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        overline="Services"
        lines={["The full program,", "under one roof."]}
        description="From the first planning call to the final debrief, ABS LLC runs every layer of a professional race operation — so your entry fee buys driving, not logistics."
        image={IMAGES.teamBriefing}
        imageAlt="ABS LLC crew briefing a driver in the pit lane"
      />

      <section data-testid="services-workflow" className="border-t border-neutral-200 bg-white">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
              How an engagement works
            </p>
            <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-[#111111] sm:text-4xl lg:text-5xl">
              Four steps. Zero surprises.
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-px bg-neutral-200 sm:grid-cols-2 lg:grid-cols-4">
            {WORKFLOW.map((step, i) => (
              <div key={step.num} className="bg-[#f8f9fa] p-8 md:p-10">
                <Reveal delay={0.07 * i}>
                  <p className="font-overline text-[11px] tracking-[0.25em] text-[#e63946]">{step.num}</p>
                  <h3 className="font-display mt-4 text-xl font-bold tracking-tight text-[#111111]">{step.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-600">{step.text}</p>
                </Reveal>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="services-list" className="bg-white">
        <div className="mx-auto max-w-7xl px-5 pb-20 md:px-8 md:pb-32">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num}>
              <article
                data-testid={`service-chapter-${s.num}`}
                className={`grid gap-8 border-t border-neutral-200 py-14 md:grid-cols-12 md:py-20 ${i === SERVICES.length - 1 ? "border-b" : ""}`}
              >
                <div className="md:col-span-2">
                  <p className="font-overline text-sm tracking-[0.2em] text-neutral-400">{s.num}</p>
                </div>
                <div className="md:col-span-5">
                  <h2 className="font-display text-2xl font-bold tracking-tight text-[#111111] md:text-4xl">{s.title}</h2>
                  <p className="mt-4 text-base leading-relaxed text-neutral-600">{s.text}</p>
                </div>
                <div className="md:col-span-5">
                  <p className="font-overline text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                    What it includes
                  </p>
                  <ul className="mt-5 space-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-neutral-700">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#e63946]" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <ServicePayments />

      <CtaBand title="Build your program." accent="One call does it." />
    </div>
  );
}
